import React, {useEffect, useState} from 'react';
import {Alert, Box, Button, Snackbar, TextField, Typography} from '@mui/material';
import {Check, ContentCopyOutlined} from '@mui/icons-material';
import {getSettingsColors} from '../settings/SettingsDesign';

export function CampaignLinkField({label, copyText = '', code = false, startAdornmentText}) {
    const [feedback, setFeedback] = useState('');
    useEffect(() => setFeedback(''), [copyText]);
    const copy = async () => {
        try {
            if (!navigator.clipboard) throw new Error('Clipboard unavailable');
            await navigator.clipboard.writeText(copyText);
            setFeedback('success');
        } catch {
            setFeedback('error');
        }
    };
    return <Box sx={{minWidth: 0, p: 1.5, borderRadius: '10px', bgcolor: theme => getSettingsColors(theme).card}}>
        <Box sx={{display: 'flex', alignItems: 'center', gap: 1, mb: 0.75}}>
            {startAdornmentText && <Typography component="span" sx={{fontSize: 10, fontWeight: 700, color: 'primary.main'}}>{startAdornmentText}</Typography>}
            <Typography component="span" sx={{fontSize: 12, fontWeight: 600, flex: 1, minWidth: 0}}>{label}</Typography>
            <Button size="small" aria-label={`Copy ${label}`} onClick={copy} disabled={!copyText}
                startIcon={feedback === 'success' ? <Check/> : <ContentCopyOutlined/>}
                sx={{px: 1, minWidth: 0, minHeight: '28px !important', fontSize: 12, '& .MuiSvgIcon-root': {fontSize: 15}}}>
                {feedback === 'success' ? 'Copied' : 'Copy'}
            </Button>
        </Box>
        <TextField value={copyText} fullWidth multiline minRows={code ? 3 : 1} maxRows={code ? 5 : 3}
            onFocus={event => event.target.select()}
            slotProps={{input: {readOnly: true}, htmlInput: {'aria-label': label}}}
            sx={{'& .MuiOutlinedInput-root': {p: 0, bgcolor: 'transparent !important'},
                '& .MuiOutlinedInput-notchedOutline': {border: '0 !important'},
                '& .MuiOutlinedInput-input': {fontFamily: 'monospace', fontSize: {xs: '16px !important', sm: '12px !important'},
                    lineHeight: 1.7, overflowWrap: 'anywhere', bgcolor: 'transparent !important', color: 'text.secondary'}}}/>
        <Snackbar open={!!feedback} autoHideDuration={2500} onClose={() => setFeedback('')} anchorOrigin={{vertical: 'bottom', horizontal: 'center'}}>
            <Alert variant="filled" severity={feedback === 'error' ? 'error' : 'success'} onClose={() => setFeedback('')}>
                {feedback === 'error' ? 'Unable to copy. Select the text and copy it manually.' : `${label} copied`}
            </Alert>
        </Snackbar>
    </Box>;
}
